import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()
    const {canGrowNode, growNode} = map.commands
    const nodes = canGrowNode(selectedNodes)

    if (0 === nodes.length) {
        return null
    }

    return {
        key: 'grow-node-recursive',
        label: '递归加载',
        suffix: 'CTRL+ALT+L',
        onClick: () => growNode(nodes, true),
    }
}
